export enum ApiEndpoints {
  ALL_RADIOS = '/musicplayer/radios/webapp',
}
